import { useEffect, useState } from 'react';

// Section nav state for the landing pages (/year-in-photos, /photo-wall-ideas). The active section
// is the last one whose top has passed 30% of the viewport, so content above the first id has
// none. Read on scroll and resize (the 30% line moves), an observer misses jumps back to the top.
// `ids` must be a stable array (a module constant), it is an effect dependency.
const useActiveSection = (ids) => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    let frame = null;
    const update = () => {
      frame = null;
      const line = window.innerHeight * 0.3;
      const passed = ids.filter(
        (id) => document.getElementById(id)?.getBoundingClientRect().top <= line,
      );
      setActive(passed.at(-1) ?? null);
    };
    const onChange = () => {
      frame ??= window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onChange, { passive: true });
    window.addEventListener('resize', onChange);
    return () => {
      window.removeEventListener('scroll', onChange);
      window.removeEventListener('resize', onChange);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [ids]);

  return active;
};

export default useActiveSection;
